import { render, staticRenderFns } from "./flagged-costs-form-overview.vue?vue&type=template&id=5715671a&scoped=true"
import script from "./flagged-costs-form-overview.vue?vue&type=script&lang=ts"
export * from "./flagged-costs-form-overview.vue?vue&type=script&lang=ts"
import style0 from "./flagged-costs-form-overview.vue?vue&type=style&index=0&id=5715671a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5715671a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5715671a')) {
      api.createRecord('5715671a', component.options)
    } else {
      api.reload('5715671a', component.options)
    }
    module.hot.accept("./flagged-costs-form-overview.vue?vue&type=template&id=5715671a&scoped=true", function () {
      api.rerender('5715671a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cost-exclusion-step/flagged-costs-lightbox/flagged-costs-form/flagged-costs-form-overview.vue"
export default component.exports